import React from 'react';

import Command from './Command';
import Production from './Production';
import Available from './Available';
import Machines from './Machines';
import Snackbar from '../../labels/Snackbar';

import Grid from '@material-ui/core/Grid';
import { AddIcon } from '../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_styles.css';

class Xhef extends React.Component {
    state = {
        available: true,
        production: true,
        xef: [],
        machines: [],
    };

    handleHideAvailable = (event) => {
        this.setState({ available: false });
    };

    handleHideProduction = (event) => {
        this.setState({ production: false });
    };

    handleShow = (event) => {
        const varName = !this.state.production ? 'production' : 'available';
        this.setState({ [varName]: true });
    };

    static getDerivedStateFromProps(props, state) {
        const { data, machines } = props;
        if (data !== state.xef || machines !== state.machines) {
            state.xef = data;
            state.machines = machines;
            return state;
        }
        return null;
    }

    render() {
        const { machines, error, available, production } = this.state;
        const columns = 12 / (4 - (available ? 0 : 1) - (production ? 0 : 1));

        return (
            <div id="xhef-panel" className="flex_full_row padding_top_12 padding_left_6 overflow_x_scroll showbarXhef">
                <Grid container justify="center" className={'flex_grow_1'}>
                    <Grid
                        item
                        xs={12}
                        sm={columns - 1}
                        className="padding_right_6 padding_bottom_12"
                    >
                        <Machines
                            {...this.props}
                            data={machines}
                            handleOpenMachine={this.props.handleOpenMachine}
                        />
                    </Grid>

                    <Grid item xs={12} sm={columns} className="padding_right_6 padding_bottom_12">
                        <Command
                            {...this.props}
                            handleOpenRun={this.props.handleOpenRun}
                            handleOpenCommand={this.props.handleOpenCommand}
                        />
                    </Grid>
                    {production && (
                        <Grid
                            item
                            xs={12}
                            sm={columns}
                            className="padding_right_6 padding_bottom_12"
                        >
                            <Production
                                {...this.props}
                                hide={this.handleHideProduction}
                                open={production}
                                handleOpenRun={this.props.handleOpenRun}
                            />
                        </Grid>
                    )}
                    {available && (
                        <Grid
                            item
                            xs={12}
                            sm={columns + (columns < 4 ? 1 : 0)}
                            className="padding_right_6 padding_bottom_12"
                        >
                            <Available
                                {...this.props}
                                hide={this.handleHideAvailable}
                                open={available}
                                handleOpenDecrease={this.props.handleOpenDecrease}
                            />
                        </Grid>
                    )}
                    {(!production || !available) && (
                        <Grid item xs={1} sm={1} className="padding_right_24 padding_bottom_12">
                            <div
                                className="flex_full_column dottedBox height100 hand center"
                                onClick={this.handleShow}
                            >
                                <AddIcon color="primary" />
                            </div>
                        </Grid>
                    )}
                </Grid>
                {error && (
                    <Snackbar
                        open={true}
                        variant="error"
                        text={error}
                        nonavbar={true}
                        onClose={this.handleClose}
                    />
                )}
            </div>
        );
    }
}

export default Xhef;



// WEBPACK FOOTER //
// ./src/components/complex/xhef/Panel.js